import * as React from 'react';

import Icon from 'components/atoms/Icon';
import noop from 'helper/noop';

export type CtaRectProps = {
	text: string;
	delegate: (event: React.MouseEvent<HTMLAnchorElement>) => void;
	disabled?: boolean;
	loading?: boolean;
};

const CtaRect = ({ text, delegate = noop, disabled = false, loading = false }: CtaRectProps) => {
	const className = (): string => {
		const out: Array<string> = ['a-cta-rect'];
		if (disabled) {
			out.push('state-a-cta-rect--disabled');
		}
		if (loading) {
			out.push('state-a-cta-rect--loading');
		}
		return out.join(' ');
	};

	return (
		<a className={className()} onClick={disabled || loading ? noop : delegate}>
			<span className="a-cta-rect__text" dangerouslySetInnerHTML={{ __html: text }} />
			<div className="a-cta-rect__icon">
				<Icon iconName="play" />
			</div>
		</a>
	);
};

export default CtaRect;
